export enum SubmissionDataDestination {
    Submission = 'Submission',
    SubmissionAdditionalData = 'SubmissionAdditionalData',
    Herald = 'Herald',
    SubmissionForm = 'SubmissionForm',
}
